import i18n from '../../i18n';

export const MESSAGES = {
  FETCH_STATIC_VARIABLES: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the static variables.'),
      403: i18n.t('You are not allowed to fetch the static variables.'),
      404: i18n.t('The static variables you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the static variables.'),
      default: i18n.t('An error occurred fetching the static variables.')
    }
  },

  CREATE_STATIC_VARIABLES: {
    ERROR: {
      401: i18n.t('You are not authorized to create a static variable.'),
      403: i18n.t('You are not allowed to create a static variable.'),
      500: i18n.t('An error occurred creating the static variable.'),
      default: i18n.t('An error occurred creating the static variable.')
    },
    SUCCESS: {
      200: i18n.t('Static variable created successfully.')
    }
  },

  UPDATE_STATIC_VARIABLES: {
    ERROR: {
      401: i18n.t('You are not authorized to update the static variable.'),
      403: i18n.t('You are not allowed to update the static variable.'),
      404: i18n.t('The static variable you are trying to update does not exist.'),
      500: i18n.t('There was an error updating the static variable.'),
      default: i18n.t('An error occurred updating the static variable.')
    },
    SUCCESS: {
      200: i18n.t('Static variable updated successfully.')
    }
  },

  DELETE_STATIC_VARIABLES: {
    ERROR: {
      401: i18n.t('You are not authorized to delete the static variable.'),
      403: i18n.t('You are not allowed to delete the static variable.'),
      404: i18n.t('The static variable you are trying to delete does not exist.'),
      500: i18n.t('There was an error deleting the static variable.'),
      default: i18n.t('An error occurred deleting the static variable.')
    },
    SUCCESS: {
      200: i18n.t('Static variable deleted successfully.')
    }
  }
};
